/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { FormGroup } from "react-bootstrap-3";
import HelpText from "./HelpText";
import FormModal from "./FormModal";

function arrayMove(arr, previousIndex, newIndex) {
  const valueMoving = arr[previousIndex];
  arr.splice(previousIndex, 1);
  arr.splice(newIndex, 0, valueMoving);
  return arr;
}

class NestedEntityGroup extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onStartCreate = this.onStartCreate.bind(this);
    this.onStartEdit = this.onStartEdit.bind(this);
    this.onStopEdit = this.onStopEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onSort = this.onSort.bind(this);
    this.state = {
      editing: false,
    };
  }

  onChangeBasedOnSortName = ({ sortName, entities, event }) => {
    let changedValues = {
      event,
      field: this.props.field.fieldName,
    };
    if (sortName) {
      changedValues.value = entities.map((entity, index) => ({
        ...entity,
        [sortName]: index,
      }));
    } else {
      changedValues.value = entities.map(entity => ({
        ...entity,
      }));
    }
    this.props.onChange(changedValues);
  };

  onSubmit = ({ event, entity }) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const sortName = this.props.field.sortName;
    const entities = [...this.props.value];
    const indexValue = entities.findIndex(element => element._tempId === entity._tempId);
    if (indexValue >= 0) {
      entities.splice(indexValue, 1, entity);
    } else {
      entity._tempId = entities.length + 1;
      entities.splice(entities.length, 1, entity);
    }
    /** the sortName is used to give new sort values when an entity is created */
    this.onChangeBasedOnSortName({ sortName, entities, event });
  };

  onDelete = ({ event, idx }) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const sortName = this.props.field.sortName;
    const entities = [...this.props.value].filter((element, index) => idx !== index);
    this.onChangeBasedOnSortName({ sortName, entities, event });
  };

  onToggle({ event, field, entity }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const entities = [...this.props.value];
    const idx = entities.findIndex(elem => elem.id === entity.id);
    if (
      field &&
      idx &&
      entities.hasOwnProperty(idx) &&
      entities[idx].hasOwnProperty(field.fieldName)
    ) {
      entities[idx][field.fieldName] = !entities[idx][field.fieldName];
      this.props.onChange({
        event,
        value: entities,
        field: this.props.field.fieldName,
      });
    }
  }

  onSort({ id, event, entity, field, newIndex, oldIndex, swappedEntity }) {
    if (field) {
      const oldEntities = [...this.props.value];
      const entities = arrayMove(oldEntities, oldIndex, newIndex);
      entities.forEach((newEntity, idx) => (newEntity[field.fieldName] = idx));
      this.props.onChange({
        event,
        value: entities,
        field: this.props.field.fieldName,
      });
    }
  }

  onStartCreate({ event }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({
      editing: true,
      activeEntity: {},
      activeId: -1,
      activeIdx: -1,
    });
  }

  onStartEdit({ event, entity, idx }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({
      editing: true,
      activeEntity: entity,
      activeId: entity.id,
      activeIdx: idx,
    });
  }

  onStopEdit({ event } = {}) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({
      editing: false,
    });
  }

  render() {
    const {
      value,
      hasErrors,
      field,
      disabled,
      ListWidget,
      FormWidget,
      onChange,
      locales,
      tickers,
      name,
      locale,
      formValues,
    } = this.props;

    const { placeholder, introductionText, nestedTitle = "Edición", minHeight } = field;

    const { editing, activeEntity = null } = this.state;
    const { onStopEdit, onStartEdit, onStartCreate, onSubmit, onDelete, onToggle, onSort } = this;

    return (
      <div className="nestedGroup">
        <FormModal
          isOpen={editing}
          nestedTitle={nestedTitle}
          onClose={onStopEdit}
          minHeight={minHeight}>
          <FormWidget
            getListPath={() => "dummy"}
            afterSubmit={onStopEdit}
            onCancelEdit={onStopEdit}
            entity={activeEntity}
            onSubmitEntity={onSubmit}
            nested
            locales={locales}
            locale={locale}
            allEntities={value}
            parentFormValues={formValues}
          />
        </FormModal>

        <FormGroup>
          {introductionText && typeof introductionText === "string" ? (
            <HelpText text={introductionText} />
          ) : Array.isArray(introductionText) ? (
            introductionText.map(text => <HelpText text={text} />)
          ) : null}
          <ListWidget
            name={name}
            entities={value}
            locales={locales}
            locale={locale}
            tickers={tickers}
            onChange={onChange}
            onToggleListItem={onToggle}
            handleCreate={onStartCreate}
            handleEdit={onStartEdit}
            onDeleteListItem={onDelete}
            onSortListItem={onSort}
            className={`form-control ${hasErrors && "parsley-error"}`}
            placeholder={placeholder}
            disabled={disabled}
            nested
            parentFormValues={formValues}
          />
        </FormGroup>
      </div>
    );
  }
}

NestedEntityGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  entities: PropTypes.array,
  onDelete: PropTypes.func,
  onChange: PropTypes.func,
};

export default NestedEntityGroup;
